import { asyncAction } from '../common';
import * as api from '../../api/templates';
import { typesToTemplates } from '../../constants/dashboards';
import { getTypeField } from '../../utils/event/createQueries';
import { dateTypes } from '../../constants/metainf';
import { PARAM_CSV } from '../../utils/csv';
import { setEventCsvColumn } from '../events/csvEvents';

export const fetchTemplates = () => asyncAction('FETCH_TEMPLATES', api.getTemplates);

export const createTemplate = (templateName, templateDescription, type) =>
  asyncAction(
    `CREATE_TEMPLATE_${type}`,
    api.createTemplate(templateName, templateDescription, type)
  );

export const updateTemplate = (templateName, templateDescription, type) =>
  asyncAction('UPDATE_TEMPLATE', api.updateTemplate(templateName, templateDescription, type));

export const deleteTemplate = (id) => asyncAction('DELETE_TEMPLATE', api.deleteTemplate(id));

export const toggleTemplate = (template) => ({
  type: `SET_TEMPLATE_${template.type}`,
  template,
});

// при заполнении ивента из темплэйта нужно изменить настройки CSV в зависимости от выбранного groupBy ивента
export const toggleEventTemplate = (template) => (dispatch, getState) => {
  dispatch(toggleTemplate(template));
  const state = getState();
  const groupBy = template.queries[0].query.groupBy[0];
  const { type } = getTypeField(groupBy, state);
  const typeIsDate = dateTypes.includes(type);
  dispatch(
    setEventCsvColumn({
      [PARAM_CSV.GROUP_BY]: !typeIsDate,
      [PARAM_CSV.GROUP_BY_DAY]: typeIsDate,
    })
  );
};

export const resetTemplate = (type) => ({
  type: `RESET_TEMPLATE_${type}`,
});

export const setTemplateResult = (type, templateResult) => ({
  type: `SET_RESULT_${type}`,
  templateResult,
});

export const toggleDashboardTemplate = (template, unitId) => ({
  type: `DASHBOARD_SET_TEMPLATE_${typesToTemplates[template.type]}`,
  template,
  unitId,
});

export const resetDashboardTemplate = (type, id) => ({
  type: `DASHBOARD_RESET_TEMPLATE_${type}`,
  id,
});
